module.exports = __webpack_public_path__ + "img/OM.bdc269ae.png";